import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";

const CategoryEdit = () => {
  const [CategoryEditUser, setCategoryEditUser] = useState({
    category_id: "",
    category_name: "",
    cat_stock: "",
    status: "",
    cat_created_by: "",
    image: "",
  });

  const [CategoryImage, setCategoryImage] = useState(null);
  const [previewImage, setPreviewImage] = useState(null);

  const { id } = useParams();
  const navigate = useNavigate();

  // ==========================================
  // 🔥 GET CATEGORY BY ID  (YOUR REAL API)
  // ==========================================
  
  useEffect(() => {
    const fetchCategory = async () => {
      try {

        const formData = new FormData();
        formData.append("category_id", id);

        const response = await axios.post(
          "https://cyberathon.com/multivendor/index.php/Api/Master_controller/get_main_category_by_id",
          formData,
          { 
            headers: { "Content-Type": "multipart/form-data" },
           },
        );

        console.log("Fetch category response:", response.data);

        if (response.data.status === true || response.data.success === "1") {
          const result = response.data.data;

          setCategoryEditUser({
            category_id: result.category_id,
            category_name: result.category_name,
            cat_stock: result.cat_stock || "",
            status: result.status || "",
            cat_created_by: result.cat_created_by || "",
            image: result.image,
          });

          setPreviewImage(
            result.image
              ? `https://cyberathon.com/multivendor/${result.image}`
              : null
          );
        } else {
          toast.error("Failed to fetch category!");
        }
      } catch (error) {
        console.error("Error fetching category:", error);
        toast.error("Failed to fetch category!");
      }
    };

    fetchCategory();
  }, [id]);

  const changeHandler = (e) => {
    const { name, value } = e.target;
    setCategoryEditUser({ ...CategoryEditUser, [name]: value });
  };

  const handleImage = (e) => {
    const file = e.target.files[0];
    setCategoryImage(file);
    if (file) setPreviewImage(URL.createObjectURL(file));
  };

  // ==========================================
  // 🔥 UPDATE CATEGORY (YOUR REAL API)
  // ==========================================
  const submitForm = async (e) => {
    e.preventDefault();

    const formData = new FormData();

    formData.append("category_id", id);
    formData.append("category_name", CategoryEditUser.category_name);
    formData.append("cat_stock", CategoryEditUser.cat_stock);
    formData.append("status", CategoryEditUser.status);
    formData.append("cat_created_by", CategoryEditUser.cat_created_by);

    if (CategoryImage) {
      formData.append("image", CategoryImage);
      formData.append("cat_image", CategoryImage);
    }

    try {
      const response = await axios.post(
        "https://cyberathon.com/multivendor/index.php/Api/Master_controller/Update_main_category",
        formData,
        { headers: { "Content-Type": "multipart/form-data" } }
      );

      if (response.data.status === true || response.data.status === "true") {
        toast.success(response.data.message || "Category updated successfully");
        navigate("/category-list");
      } else {
        toast.error(response.data.message || "Failed to update category");
      }
    } catch (error) {
      console.error("Update error:", error);
      toast.error("Something went wrong!");
    }
  };

  return (
    <div className="page-content">
      <div className="container-fluid">

        {/* PAGE TITLE */}
        <div className="row">
          <div className="col-12">
            <div className="page-title-box">
              <h4 className="mb-0 fw-semibold">Category Edit</h4>
              <ol className="breadcrumb mb-0">
                <li className="breadcrumb-item">
                  <a href="javascript:void(0);">Category</a>
                </li>
                <li className="breadcrumb-item active">Category Edit</li>
              </ol>
            </div>
          </div>
        </div>

        {/* FORM */}
        <div className="row">
          <div className="col-xl-9 col-lg-8 ">

            {/* IMAGE SECTION */}
            <div className="card">
              <div className="card-header">
                <h4 className="card-title">Update Thumbnail Photo</h4>
              </div>
              <div className="card-body">
                <div className="dropzone bg-light-subtle py-5 text-center">
                  <input type="file" onChange={handleImage} />
                  {previewImage && (
                    <img
                      src={previewImage}
                      alt="Preview"
                      className="mt-3"
                      style={{ width: "100px" }}
                    />
                  )}
                </div>
              </div>
            </div>

            {/* GENERAL INFO */}
            <div className="card">
              <div className="card-header">
                <h4 className="card-title">General Information</h4>
              </div>
              <div className="card-body">
                <form onSubmit={submitForm}>
                  <div className="row">

                    <div className="col-lg-6 mb-3">
                      <label className="form-label">Category Title</label>
                      <input
                        type="text"
                        className="form-control"
                        name="category_name"
                        value={CategoryEditUser.category_name}
                        onChange={changeHandler}
                        required
                      />
                    </div>

                    <div className="col-lg-6 mb-3">
                      <label className="form-label">Created By</label>
                      <select
                        className="form-control"
                        name="cat_created_by"
                        value={CategoryEditUser.cat_created_by}
                        onChange={changeHandler}
                      >
                        <option value="">Select Crater</option>
                        <option value="Seller">Seller</option>
                        <option value="Admin">Admin</option>
                        <option value="Other">Other</option>
                      </select>
                    </div>

                    <div className="col-lg-6 mb-3">
                      <label className="form-label">Stock</label>
                      <input
                        type="number"
                        className="form-control"
                        name="cat_stock"
                        value={CategoryEditUser.cat_stock}
                        onChange={changeHandler}
                      />
                    </div>

                    <div className="col-lg-6 mb-3">
                      <label className="form-label">Status</label>
                      <select
                        className="form-control"
                        name="status"
                        value={CategoryEditUser.status}
                        onChange={changeHandler}
                      >
                        <option value="">Select Status</option>
                        <option value="Active">Active</option>
                        <option value="InActive">InActive</option>
                      </select>
                    </div>

                  </div>

                  <div className="p-3 bg-light mb-3 rounded">
                    <div className="row justify-content-end g-2">
                      <div className="col-lg-2">
                        <button type="submit" className="btn btn-outline-secondary w-100">
                          Save Change
                        </button>
                      </div>
                      <div className="col-lg-2">
                        <Link to="/category-list" className="btn btn-primary w-100">
                          Cancel
                        </Link>
                      </div>
                    </div>
                  </div>

                </form>
              </div>
            </div>

          </div>
        </div>

      </div>

      {/* Footer */}
            <footer className="footer">
              <div className="container-fluid">
                <div className="row">
                  <div className="col-12 text-center">
                    © Venton. Crafted by{" "}
                    <iconify-icon
                      icon="iconamoon:heart-duotone"
                      className="fs-18 align-middle text-danger"
                    />{" "}
                    <Link to="#" className="fw-bold footer-text" target="_blank">
                      Techzaa
                    </Link>
                  </div>
                </div>
              </div>
            </footer>
    </div>
  );
};

export default CategoryEdit;